import { HTMLAttributes } from 'react';
import { CardContent } from '@/shared/ui/core';


export function AuthCardContent ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <CardContent
            className={ className }
            data-template="auth-card-content"
            { ...props }
        />
    );
}
